import {AfterViewInit, Component, ElementRef, forwardRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

declare var Quill: any;

@Component({
    selector: 'db-quill-editor',
    templateUrl: './quill-editor.component.html',
    styleUrls: ['./quill-editor.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => QuillEditorComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class QuillEditorComponent implements OnInit, AfterViewInit, OnDestroy, ControlValueAccessor {
  private quill: any;
  @Input() placeholder: string;
  @ViewChild('quillElem') quillElem: ElementRef;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const toolbarOptions = [
      [{'header': [1, 2, 3, 4, 5, 6, false]}],  // custom dropdown
      ['bold', 'italic'],
      [{'list': 'ordered'}, {'list': 'bullet'}, { 'align': '' }, { 'align': 'center' }, { 'align': 'right' }],
      ['link']
    ];

    this.quill = new Quill(this.quillElem.nativeElement, {
      modules: {
        toolbar: toolbarOptions,
      },
      theme: 'snow',
      placeholder: this.placeholder,
      formats: ['bold', 'italic', 'list', 'link', 'size', 'header', 'align'],
    });

    // Register a change event handler
    this.quill.on('text-change', () => {
      this.onChange(this.quill.root.innerHTML);
    });

    // const tooltipSave = this.quill.theme.tooltip.save;
    // this.quill.theme.tooltip.save = function() {
    //   const errorMessage = document.createElement('div');
    //   errorMessage.textContent = 'This field is required.'; // Set your error message text
    //   errorMessage.classList.add('ql-link-err');
    //
    //   this.textbox.parentNode.insertBefore(errorMessage, this.textbox.nextSibling);
    //
    //   function toggleErrorMessage(show) {
    //     errorMessage.style.display = show ? 'block' : 'none';
    //   }
    //   // overwrite save link functionality
    //   let url = this.textbox.value;
    //
    //   if(url.indexOf('http') === -1) {
    //     url = 'http://' + url;
    //   }
    //
    //   this.textbox.classList.remove('ql-error');
    //   // validate url
    //   if(false) {
    //     tooltipSave.call(this);
    //   }
    //   else {
    //     // show error in tooltip
    //     this.textbox.classList.add('ql-error');
    //     toggleErrorMessage(true);
    //   }
    // };
  }

  ngOnDestroy(): void {
    if (this.quill) {
      this.quill.off('text-change');
      this.quill = null;
    }
  }

  // ControlValueAccessor methods
  writeValue(value: any): void {
    if (this.quill) {
      const delta = this.quill.clipboard.convert(value);
      this.quill.setContents(delta);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  private onChange = (value: string) => {
  };
  private onTouched = () => {
  };
}





